import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { RECURRENCE_TYPES } from "../../../constants/recurrenceConstants";
import DailyPicker   from "./DailyPicker";
import WeeklyPicker  from "./WeeklyPicker";
import MonthlyPicker from "./MonthlyPicker";
import YearlyPicker  from "./YearlyPicker";

const T = {
  primary:     "#0D9488",
  primaryDark: "#0F766E",
  primaryLight:"#F0FDFA",
  border:      "#E2E8F0",
  text:        "#0F172A",
  textSub:     "#475569",
  textMuted:   "#94A3B8",
  surface:     "#FFFFFF",
  bg:          "#F1F5F9",
};

const PatternPicker = ({ values, set, setMany, errors }) => {
  const pickerProps = { values, set, setMany, errors };

  return (
    <Box>
      {/* Type selector */}
      <Typography sx={{ fontSize: "13px", fontWeight: 600, color: T.textSub, mb: 1.5 }}>
        Repeat
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap" sx={{ mb: 3 }}>
        {RECURRENCE_TYPES.map(({ value, label, icon: Icon }) => {
          const active = values.recurrenceType === value;
          return (
            <Box
              key={value}
              onClick={() => set("recurrenceType", value)}
              sx={{
                display: "flex", alignItems: "center", gap: "6px",
                px: "14px", py: "8px",
                borderRadius: "9px",
                border: `1.5px solid ${active ? T.primary : T.border}`,
                bgcolor: active ? T.primaryLight : T.surface,
                color:   active ? T.primary      : T.textSub,
                cursor: "pointer",
                fontWeight: active ? 700 : 500,
                fontSize: "13px",
                transition: "all 0.15s",
                "&:hover": { borderColor: T.primary, color: T.primary },
                userSelect: "none",
              }}
            >
              <Icon size={14} />
              {label}
            </Box>
          );
        })}
      </Stack>

      {/* Sub-picker for selected type */}
      <AnimatePresence mode="wait">
        <motion.div
          key={values.recurrenceType}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -6 }}
          transition={{ duration: 0.18 }}
        >
          <Box
            sx={{
              p: 2.5,
              borderRadius: "12px",
              border: `1px solid ${T.border}`,
              bgcolor: T.bg,
            }}
          >
            {values.recurrenceType === "daily"   && <DailyPicker   {...pickerProps} />}
            {values.recurrenceType === "weekly"  && <WeeklyPicker  {...pickerProps} />}
            {values.recurrenceType === "monthly" && <MonthlyPicker {...pickerProps} />}
            {values.recurrenceType === "yearly"  && <YearlyPicker  {...pickerProps} />}
            {values.recurrenceType === "custom"  && <DailyPicker   {...pickerProps} />}
          </Box>
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default PatternPicker;
